import React, { createContext, useState } from "react";

export const LiveChatReconnectContext = createContext();

export const LiveChatReconnectProvider = ({ children }) => {
  // Generic reconnect state
  const [isReconnect, setIsReconnect] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [chatData, setChatData] = useState(null);
  const [telemetryData, setTelemetryData] = useState(null);
  // AWS Connect-specific state
  const [chatSession, setChatSession] = useState(null); // Active ChatJS session
  const [voiceSession, setVoiceSession] = useState(null); // Active Voice session (if applicable)
  const [contactId, setContactId] = useState(null); // AWS Connect contact ID
  const [errorMessage, setErrorMessage] = useState(""); // Error message for chat failures
  const [isAgentTyping, setIsAgentTyping] = useState(false); // Track if agent is typing
  const [agentTypingName, setAgentTypingName] = useState(""); // Store agent's name who is typing
  return (
    <LiveChatReconnectContext.Provider value={{ 
      // Generic reconnect state
      isReconnect, 
      setIsReconnect, 
      isPopupVisible, 
      setIsPopupVisible,
      chatData,
      setChatData,
      telemetryData,
      setTelemetryData,
      // AWS Connect-specific state
      chatSession,
      setChatSession,
      voiceSession,
      setVoiceSession,
      contactId,
      setContactId,
      errorMessage,
      setErrorMessage,
      isAgentTyping,
      setIsAgentTyping,
      agentTypingName,
      setAgentTypingName
    }}>
    {children}
    </LiveChatReconnectContext.Provider>
  );
};
